export class SelectedFields {
  candidate: string[];
  contact: string[];
  company: string[];
}

export class ExtraReportFields {
  id: number;
  entity: string;
  fieldName: string;
}
